




































const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;

import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { CookieHelper } from "@/helper/cookieHelper";
import { DateHelper } from "@/helper/dateHelper";


@Component({
  components: {
  }
})

export default class DeleteDesign extends Vue {
  @Prop() private deleteDesignModalCallback! : any;

  private onOk() {

    this.deleteDesignModalCallback()
    this.$emit("close");

  }
  
  //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }
}
